export default [{
  path: '/manage',
  name: '',
  component: resolve => require(['@/views/home'], resolve),
  children: [
    // {
    //   path: 'contribute',
    //   name: '投稿 ',
    //   meta: {
    //     title: '投稿'
    //   },
    //   component: resolve => require(['@/views/manage/contribute'], resolve),
    // },
    {
      path: 'author',
      name: '投稿首页 ',
      meta: {
        title: '投稿首页'
      },
      component: resolve => require(['@/views/manage/author'], resolve),
    },
    {
      path: 'personalData',
      name: '个人资料',
      meta: {
        title: '个人资料'
      },
      component: resolve => require(['@/views/manage/personalData'], resolve),
    },
    // {
    //   path: 'author',
    //   name: '首页',
    //   meta: {
    //     title: '首页'
    //   },
    //   component: resolve => require(['@/views/manage/author/index'], resolve),
    // },
    {
      path: 'submission',
      name: '',
      meta: {
        title: '投稿须知'
      },
      component: resolve => require(['@/views/manage/submission'], resolve),
    },
    {
      path: 'orderManagement',
      name: ' 订单管理',
      meta: {
        title: '订单管理'
      },
      component: resolve => require(['@/views/manage/orderManagement'], resolve),
    },
    {
      path: 'invoiceManage',
      name: '开票查询',
      meta: {
        title: '开票查询'
      },
      component: resolve => require(['@/views/manage/invoiceManage'], resolve),
    },
    {
      path: 'feedback',
      name: '意见反馈',
      meta: {
        title: '意见反馈'
      },
      component: resolve => require(['@/views/manage/feedback'], resolve),
    },
    {
      path: 'orderManagement/readyOrderdDetails',
      name: '订单管理',
      meta: {
        title: '订单管理'
      },
      component: resolve => require(['@/views/manage/orderManagement/readyOrderdDetails'], resolve),
    },
   
    {
      path: 'contributorInformation',
      name: '在线投稿',
      meta: {
        title: '在线投稿'
      },
      component: resolve => require(['@/views/manage/contributorInformation'], resolve),
    },
    {
      path: 'paymentCenter',
      name: '支付中心',
      meta: {
        title: '支付中心'
      },
      component: resolve => require(['@/views/manage/paymentCenter'], resolve),
    },
    {
      path: 'draftBox',
      name: ' 草稿箱',
      meta: {
        title: '草稿箱'
      },
      component: resolve => require(['@/views/contributionManagement/draftBox'], resolve),
    },


//  {
//    path: 'siteManagement',
//    name: '站点管理',
//    meta: {
//      title: '站点管理'
//    },
//    component: resolve => require(['@/views/manage/siteManagement'], resolve),
//  },
//  {
//    path: 'siteManagement/addSite',
//    name: '添加站点',
//    meta: {
//      title: '添加站点'
//    },
//    component: resolve => require(['@/views/manage/siteManagement/addSite'], resolve),
//  },
//  {
//    path: 'BasicInfoManagement',
//    name: '基本信息管理',
//    meta: {
//      title: '基本信息管理'
//    },
//    component: resolve => require(['@/views/manage/BasicInfoManagement'], resolve),
//  },
//  {
//    path: 'BasicInfoManagement/addInfo',
//    name: '添加基本信息管理',
//    meta: {
//      title: '添加基本信息管理'
//    },
//    component: resolve => require(['@/views/manage/BasicInfoManagement/addInfo'], resolve),
//  },
//  {
//    path: 'userManagement',
//    name: '用户管理',
//    meta: {
//      title: '用户管理'
//    },
//    component: resolve => require(['@/views/manage/privilegeManagement/userManagement'], resolve),
//  },
//  {
//    path: 'roleManagement',
//    name: '用户管理',
//    meta: {
//      title: '用户管理'
//    },
//    component: resolve => require(['@/views/manage/privilegeManagement/roleManagement'], resolve),
//  },
  ]
},//第二大类共用部分
{
  path: '/loginAdmin',
  name: '用户反馈',
  meta: {
    title: '用户反馈'
  },
  component: resolve => require(['@/views/manage/loginAdmin'], resolve),
},
]



// WEBPACK FOOTER //
// ./src/router/manage_routers.js